var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"region-select"},[_c('el-cascader',_vm._b({ref:"refRegion",attrs:{"value":_vm.value,"options":_vm.regionList,"props":_vm.regProp,"size":"small","filterable":"","disabled":!_vm.enabled},on:{"change":_vm.handleChange}},'el-cascader',_vm.iptConf,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f669450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RegionSelect.vue
// module id = null
// module chunks = 